import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import { ContaService } from '../../../../../shared/services/conta/conta.service';
import { VendaService } from '../../../../../shared/services/venda/venda.service';
import { TransacaoService } from '../../../../../shared/services/transacao/transacao.service';
import { brands } from '../../../../../shared/services/cartao/brands.service';

import * as moment from 'moment';

declare var $;

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.scss']
})
export class ClienteComponent implements OnInit {
  public clientId = null;

  public user = null;
  public client: any = null;

  public sales = [];
  public transactions = [];

  public tabNumber = 1;

  constructor(
    private route: ActivatedRoute,
    private contaService: ContaService,
    private vendaService: VendaService,
    private transacaoService: TransacaoService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.getClientId();
    this.getAccountId();
    this.getClient();
  }

  getAccountId() {
    this.user = this.localStorageService.get('login');
  }

  getClientId() {
    this.clientId = this.route.snapshot.params['id'] ? this.route.snapshot.params['id'] : null;
  }

  getClient() {
    this.contaService.obterClienteDetalhado(this.user.PersonId, this.clientId).subscribe((data) => {
      this.client = data;

      this.getSales();
      this.getTransactions();
    }, (err) => {
      console.error(err);
    });
  }

  getSales() {
    this.vendaService.obterPorClienteId(this.clientId).subscribe((data: any[]) => {
      this.sales = data;
    }, (err) => {
      console.error(err);
    });
  }

  getTransactions() {
    this.transacaoService.obterPorClienteId(this.clientId).subscribe((data: any[]) => {
      this.transactions = data;
    }, (err) => {
      console.error(err);
    });
  }

  selectTab(tab) {
    this.tabNumber = tab;
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
  }

  formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  getCreditCardBrand(brand) {
    return brands.find(b => b.name === brand).className;
  }

  getTransactionStatus(transaction) {
    let situation = '';

    switch (transaction.CodigoRetorno) {
      case '4':
      case '6':
      case '00':
      case '000':
      situation = 'Aprovada';
      break;
      default:
      situation = 'Reprovada';
    }

    switch (transaction.Situacao) {
      case 'Estornado':
        situation = 'Estornada';
        break;
    }

    return situation;
  }

  getNextDate(sale) {
    const cobrancasAbertas = sale.Cobrancas.filter(c => c.Situacao === 'Aberta');

    cobrancasAbertas.sort(function(a, b) {
      const dateA = a.DataCobranca;
      const dateB = b.DataCobranca;
      if (!moment(dateA).isAfter(dateB)) {
        return -1;
      }
      if (moment(dateA).isAfter(dateB)) {
        return 1;
      }
      return 0;
    });

    return cobrancasAbertas.length > 0 ? moment(cobrancasAbertas[0].DataCobranca).format('DD/MM/YYYY') : '';
  }

  maskCpfCnpj(cpfCnpj) {
    if (cpfCnpj && cpfCnpj.length === 11) {
      return this.cpfMask(cpfCnpj);
    }

    if (cpfCnpj && cpfCnpj.length === 14) {
      return this.cnpjMask(cpfCnpj);
    }

    return '';
  }

  cpfMask (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
  }

  cnpjMask (value) {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/clientes/cliente/cliente.component.ts